<template>
  <div class="form-group">
    <label v-if="label" class="form-label" :data-content="label">
      <span>{{ label }}</span>
      <span v-if="required"> *</span>
    </label>
    <div class="row row-narrower">
      <div class="col-md-3"
           v-for="c in currencies"
           :key="`cur-${c}`">
        <label class="text-uppercase form-label small">{{ c }}</label>
        <input type="number"
               step="0.1"
               class="form-control"
               @input="(...args) => handleInput(c, ...args)"
               @keyup="$emit('keyup', $event)"
               @keyup.enter="$emit('enter')"
               :readonly="readonly ? readonly : false"
               :value="modelValue ? modelValue[c] : ''"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { currencyForJson as currencies } from "@/dictionaries/dictionary"
import { copyObject } from "@/extensions/prototypes/prototypes"
import { watch } from "vue"

const props = defineProps({
  label: {},
  modelValue: {},
  readonly: {},
  placeholder: String,
  required: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits([
  'keyup',
  'enter',
  'update:modelValue'
])

// a changed copy of the amounts by currency
const handleInput = (c, e) => {
  let obj = copyObject(props.modelValue)
  obj[c] = e.target.value
  emit('update:modelValue', obj)
}

// an empty value becomes zero in every currency
watch(() => props.modelValue, (val) => {
  if(!val) {
    const obj = currencies.reduce((o, key) => ({ ...o, [key]: 0}), {})
    emit('update:modelValue', obj)
  }
}, { immediate: true })
</script>
